import { saveItemLocalStorage, getPersistLocalStorage } from "helpers/localstorageTool";
import { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
  setInactiveSession,
  closeSession,
} from "redux/actions/login/loginActions";

const INACTIVITY_DURATION = parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT) || 15 * 60;
const INTERVAL = 1000;

export const useInactivitySession = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [elapsedTime, setElapsedTime] = useState({ min: 0, seg: 0 });
  const lastActivityTimeRef = useRef(Date.now());
  const pathnameRef = useRef(pathname);
  pathnameRef.current = pathname;

  const handleInactivity = useCallback(() => {
    saveItemLocalStorage("route", pathnameRef.current);
    dispatch(closeSession());
    dispatch(setInactiveSession(true));
    window.location.href = "/auth/login";
  }, [dispatch]);

  const handleUserActivity = useCallback(() => {
    lastActivityTimeRef.current = Date.now();
  }, []);

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "touchstart", "keypress", "wheel"];
    events.forEach((e) => document.addEventListener(e, handleUserActivity));
    return () => events.forEach((e) => document.removeEventListener(e, handleUserActivity));
  }, [handleUserActivity]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      let contactData = {};
      try {
        contactData = getPersistLocalStorage("contact-data") || {};
      } catch (error) {
        console.warn('Failed to read contact data from localStorage:', error);
      }
      const isOnCall = !!contactData?.callID;

      if (isOnCall) {
        lastActivityTimeRef.current = Date.now();
        setElapsedTime(prev => prev.min === 0 && prev.seg === 0 ? prev : { min: 0, seg: 0 });
        return;
      }

      const elapsed = Math.floor(
        (Date.now() - lastActivityTimeRef.current) / 1000
      );
      setElapsedTime({ min: Math.floor(elapsed / 60), seg: elapsed % 60 });

      if (elapsed >= INACTIVITY_DURATION) handleInactivity();
    }, INTERVAL);
    return () => clearInterval(intervalId);
  }, [handleInactivity]);

  return elapsedTime;
};
